<h2 mat-dialog-title>Deny API Key Request</h2>

<div mat-dialog-content>
  <p>
    Enter a reason for denying the request from
    <strong>{{ data.userName }}</strong>.
  </p>

  <form [formGroup]="form">
    <mat-form-field appearance="outline" class="reason-field">
      <mat-label>Denial reason</mat-label>
      <textarea
        matInput
        formControlName="deniedReason"
        rows="5"></textarea>

      <mat-error>
        @if (form.controls.deniedReason.hasError('required')) {
          A denial reason is required.
        } @else if (form.controls.deniedReason.hasError('maxlength')) {
          Denial reason must be 1000 characters or less.
        }
      </mat-error>
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button type="button" mat-dialog-close>
    Cancel
  </button>

  <button
    mat-flat-button
    color="warn"
    type="button"
    [disabled]="form.invalid"
    (click)="submit()">
    Deny Request
  </button>
</div>

